import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import { Box } from "@mui/material";

import WorkingWithAi from "../../assets/WorkingWithAiLight.png";

export default function ReasoningEngine({ scrollToBottom, lessThanXL }) {
  return (
    <Box
      sx={{
        paddingLeft: !lessThanXL ? "70px" : "21px",
        paddingRight: !lessThanXL ? "70px" : "21px",
      }}
    >
      <Grid container>
        <Grid item md={12}>
          <Box
            sx={{
              borderRadius: "16px",
              paddingTop: !lessThanXL ? "30px" : "80px",
              paddingBottom: !lessThanXL ? "30px" : "80px",
            }}
          >
            <Grid container alignItems="center">
              <Grid item sm={12} md={7}>
                <Typography
                  sx={{
                    color: "#1F1F1F",
                    fontSize: !lessThanXL ? "34px" : "32px",
                  }}
                  component={"span"}
                  lineHeight={"normal"}
                  fontWeight="700"
                  gutterBottom
                >
                  RAG-Powered
                </Typography>{" "}
                <Typography
                  fontWeight="700"
                  component="span"
                  sx={{
                    paddingRight: "5px",
                    fontSize: !lessThanXL ? "34px" : "32px",
                    fontStyle: !lessThanXL ? "italic" : "",
                    background: (theme) => theme.palette.gradient.toTop,
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    lineHeight: "normal",
                  }}
                >
                  Reasoning Engine
                </Typography>{" "}
                {!lessThanXL ? (
                  ""
                ) : (
                  <Grid
                    mt={5}
                    mb={5}
                    item
                    sm={12}
                    md={6}
                    sx={{ textAlign: "center" }}
                  >
                    <img
                      loading="lazy"
                      height="250px"
                      src={WorkingWithAi}
                      alt="Person working with Dokusense AI using tablet"
                    />
                  </Grid>
                )}
                <Typography
                  component={"div"}
                  fontSize={!lessThanXL ? "18px" : "20px"}
                  fontWeight={"400"}
                  color="#393939"
                  variant="body1"
                  mb={3}
                  mt={5}
                >
                  At the core of DokuSense is our proprietary reasoning engine,
                  built on an advanced Retrieval-Augmented Generation (RAG)
                  architecture - designed to combine precise retrieval with
                  explainable, document-grounded generation. It delivers
                  accurate answers with full traceability to the original
                  source.
                  <br />
                  <br />
                  It doesn't just retrieve -{" "}
                  <Typography
                    fontWeight="400"
                    component="span"
                    sx={{
                      paddingRight: "5px",
                      fontSize: !lessThanXL ? "18px" : "20px",
                      fontStyle: !lessThanXL ? "italic" : "",
                      background: (theme) => theme.palette.gradient.toTop,
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      lineHeight: "normal",
                    }}
                  >
                    it understands interprets, and explains.
                  </Typography>
                  <br />
                  <br />
                  Our engine handles a wide range of documents challenges:
                  <ul style={{ marginTop: "0px", paddingLeft: "20px" }}>
                    <li>
                      From comparing clauses and calculating values in tables to
                      identifying inconsistencies and extracting obligations -
                      all with high precision
                    </li>

                    <li>
                      You get not just answers, but structured reasoning,
                      grounded in your document's content and fully traceable.
                    </li>
                  </ul>
                </Typography>
              </Grid>

              {!lessThanXL ? (
                <Grid mt={5} item sm={12} md={5} sx={{ textAlign: "center" }}>
                  <img
                    loading="lazy"
                    height={"580px"}
                    width={"500px"}
                    src={WorkingWithAi}
                    alt="Person working with Dokusense AI using tablet"
                  />
                </Grid>
              ) : (
                ""
              )}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
